(() => {
  'use strict';

  // Both clocks use the same deadline and duration as the source page.
  const storageKey = 'voltturi_sale_deadline_v2';
  const durationMs = 7451000;
  const now = Date.now();
  let deadline = now + durationMs;
  try {
    const saved = Number(window.localStorage.getItem(storageKey));
    if (Number.isFinite(saved) && saved > now) deadline = saved;
    else window.localStorage.setItem(storageKey, String(deadline));
  } catch (_) {
    // The countdown still works when the browser denies local storage.
  }

  function updateClocks() {
    const total = Math.floor(Math.max(0, deadline - Date.now()) / 1000);
    const values = {
      hours: String(Math.floor(total / 3600)).padStart(2, '0'),
      minutes: String(Math.floor((total % 3600) / 60)).padStart(2, '0'),
      seconds: String(total % 60).padStart(2, '0')
    };
    document.querySelectorAll('[data-japan-clock]').forEach((node) => {
      node.textContent = values[node.dataset.japanClock];
    });
  }

  updateClocks();
  window.setInterval(updateClocks, 1000);
  document.addEventListener('shopify:section:load', updateClocks);

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a');
    if (!link || !link.closest('[data-japan-page]')) return;

    if (link.hasAttribute('data-japan-product-link') && link.dataset.productReady !== 'true') {
      event.preventDefault();
      window.alert(link.dataset.productMessage);
      return;
    }

    if (link.getAttribute('href') === '#offer') {
      event.preventDefault();
      document.getElementById('offer')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
})();
